export const SAVED_AS_DRAFT = "Application was saved as draft";
export const APPLICATION_SAVED = "Application saved!";
export const COMPONENT_PUBLISHED = "Your component was successfully published!";
export const COMPONENT_FAILED_TO_PUBLISH =
    "Your transaction could not be verified. The component was not published!";
export const COST_APPROX = "The cost is approximately";
export const CLAIM_SUCCESSFUL =
    "Your claim was successful and the fees/rewards were added to your wallet";
export const PAYMENT_PROCESSING = "Payment is processing, you will be " +
"notified by metamask once complete";